import Switch from "../Switch";

const ToggleRow = ({ label, checked, onChange, disabled = false, flat = false }) => (
    <div
        className={`flex items-center justify-between px-3 py-2.5 ${
            flat
                ? ""
                : `rounded-lg bg-charleston-green border border-zinc-700 ${disabled ? "" : "hover:border-zinc-600"}`
        }`}
    >
        <span className="text-sm text-zinc-200">{label}</span>
        <Switch checked={checked} onChange={onChange} disabled={disabled} />
    </div>
);

export default ToggleRow;
